import { CardComponentProps } from "@~/types/types";
import styles from "./RemoveButton.module.scss";
import { CloseOutlined as Close24PxOutlinedIcon } from "@JohnLewisPartnership/jl-design-system/dist/components/icons/CloseOutlined";
import classNames from "classnames/bind";
import { REMOVE_PRODUCT } from "@~/utils/events";

const cx = classNames.bind(styles);

export function RemoveButton({
  product,
  configProps,
}: Pick<CardComponentProps, "product" | "configProps">) {
  const { title } = product;
  const rightAligned = configProps?.rightAligned;

  const clickHandler = () => {
    window.dispatchEvent(new CustomEvent(REMOVE_PRODUCT, { detail: product }));
  };

  return (
    <button
      onClick={clickHandler}
      aria-label={`Remove ${title}`}
      data-component="RemoveButton"
      className={cx("remove-button", {
        "right-aligned": rightAligned,
        "left-aligned": !rightAligned,
      })}
    >
      <Close24PxOutlinedIcon title="Remove product" size="medium" />
    </button>
  );
}
